import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "no-data"
}
const _hoisted_3 = ["src"]

import { computed, watch, onMounted } from 'vue';
import { forecastData, forecastColors } from '@/eventBus';
import moment from 'moment';
import 'moment/locale/fr';

interface ForecastDay {
  date: string;
  day: {
    maxtemp_c: number;
    mintemp_c: number;
    condition: {
      text: string;
      code: number;
    };
  };
}


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "ForecastWidget",
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: { type: Boolean },
    borderRadius: {},
    fontSize: {},
    config: {}
  },
  setup(__props: any) {

const props = __props;

const hasForecastData = computed(() => {
  return forecastData.value && 
         forecastData.value.forecastday && 
         Array.isArray(forecastData.value.forecastday) && 
         forecastData.value.forecastday.length > 0;
});

function getWeatherIcon(conditionCode: number) {
  try {
    if (conditionCode === 1000) {
      return require("@/assets/images/weather/sunny.png");
    } else if (conditionCode == 1006) {
      return require("@/assets/images/weather/cloudy.png");
    } else if (conditionCode == 1009 || conditionCode == 1030 || conditionCode == 1147) {
      return require("@/assets/images/weather/overcast.png");
    } else if (conditionCode === 1003) {
      return require("@/assets/images/weather/partly_cloudy.png");
    } else if ([1273, 1252, 1249, 1246, 1240, 1201, 1198, 1195, 1192, 1189, 1186, 1183, 1180, 1153, 1150, 1063, 1289].includes(conditionCode)) {
      return require("@/assets/images/weather/rainy.png");
    } else if ([1264, 1261, 1258, 1255, 1243, 1225, 1222, 1219, 1216, 1213, 1210, 1066, 1114, 1117].includes(conditionCode)) {
      return require("@/assets/images/weather/snowy.png");
    } else if ([1237, 1168, 1069, 1072, 1279, 1282].includes(conditionCode)) {
      return require("@/assets/images/weather/ice.png");
    } else if ([1087, 1276, 1279, 1282].includes(conditionCode)) {
      return require("@/assets/images/weather/thunder_storm.png");
    } else if ([1204, 1207].includes(conditionCode)) {
      return require("@/assets/images/weather/windy.png");
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

function formatDate(date: string) {
  return moment(date).locale('fr').format('dddd, D MMM').replace(/^([a-zA-Z])/, (match) => match.toUpperCase());
}


const containerWidth = computed(() => props.config?.width || 300);
const tempSize = computed(() => {
  return Math.max(20, Math.min(25, containerWidth.value / 5));
});

const iconSize = computed(() => {
  return Math.max(40, Math.min(40, containerWidth.value / 2));
});

const dateSize = computed(() => {
  return Math.max(10, Math.min(18, containerWidth.value / 10));
});

watch(
  () => forecastData.value,
  (newVal) => {
    console.log("ForecastWidget: Received new forecast data:", newVal);
    if (newVal && newVal.forecastday && Array.isArray(newVal.forecastday)) {
      console.log("ForecastWidget: Valid forecast data received:", newVal.forecastday.length, "days");
    }
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "forecast-widget",
    style: _normalizeStyle({
      color: _unref(forecastColors).fontColor,
      borderRadius: typeof _ctx.borderRadius === 'number' ? _ctx.borderRadius + 'px' : _ctx.borderRadius,
    })
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading forecast data..."))
      : (!hasForecastData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading forecast data..."))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "forecast-content",
            style: _normalizeStyle({ backgroundColor: _unref(forecastColors).backgroundColor })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(forecastData).forecastday, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "forecast-row"
              }, [
                _createElementVNode("div", {
                  class: "weather-icon",
                  style: _normalizeStyle({ width: `${iconSize.value}px`, height: `${iconSize.value}px` })
                }, [
                  _createElementVNode("img", {
                    src: getWeatherIcon(day.day.condition.code),
                    style: {"width":"100%","height":"100%"},
                    class: "weather-icon-img",
                    alt: "icon"
                  }, null, 8, _hoisted_3)
                ], 4),
                _createElementVNode("span", {
                  class: "forecast-temp",
                  style: _normalizeStyle({ fontSize: tempSize.value + 'px' })
                }, _toDisplayString(Math.round(day.day.maxtemp_c)) + "° ", 5),
                _createElementVNode("span", {
                  class: "forecast-date",
                  style: _normalizeStyle({ fontSize: dateSize.value + 'px' })
                }, _toDisplayString(formatDate(day.date)), 5)
              ]))
            }), 128))
          ], 4))
  ], 4))
}
}

})